

















































































































import { Component, Mixins, Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import RulesMixin from "#/mixins/rulesMixin";
import FireStoreMixin from "#/mixins/firestoreMixin";
import { VForm, Choice } from "@/types";
import * as appDate from "#/utility/appDate";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { ListDataset } from "@/views/aivnplan/types";

@Component({
  components: {
    AppAuthButton,
  },
})
/** 計画書自動作成 インデックス手動作成 */
export default class IndexCreate extends Mixins(
  AxiosMixin,
  UtilMixin,
  RulesMixin,
  FireStoreMixin
) {
  /** Ref */

  /** フォーム操作用 */
  @Ref("form") private readonly form!: VForm;

  /** 変数 */

  /** データセットID */
  private datasetId = 0;

  /** 指定年月 */
  private yearmonth = appDate.thisMonth();

  /** 最大処理件数 */
  private processLimit = 500;

  /** データセット選択肢 */
  private datasetChoice: Choice[] = [];

  /** フィルター用キーワード */
  private searchKeyword = "";

  /** 1ページあたりの表示件数 */
  private itemPerPage = 25;

  /** 表の現在のページ数 */
  private pageNo = 1;

  /** データセット */
  private datasets: ListDataset[] = [];

  /** データテーブル用ヘッダー */
  private headers = [
    {
      text: "データセット名",
      align: "start",
      value: "name",
      filterable: true,
      sortable: false,
    },
    {
      text: "コメント",
      align: "start",
      value: "comment",
      filterable: true,
      sortable: false,
    },
    {
      text: "最終更新者",
      align: "start",
      value: "editor_admin_name",
      filterable: false,
      sortable: false,
    },
    {
      text: "最終更新日時",
      align: "start",
      value: "updated_at",
      filterable: false,
    },
    {
      text: "",
      value: "actions",
      sortable: false,
      align: "end",
    },
  ];

  /** 関数 */

  async created() {
    this.fetch();
    this.fetchDataset();
  }

  /** 取得 */
  private fetch() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/index/form/get",
      {},
      async (res) => {
        this.datasetChoice = res.data.dataset_choice;

        // 先頭の選択肢を選択した状態にしておく
        if (this.datasetChoice && this.datasetChoice.length > 0) {
          this.datasetId = this.datasetChoice[0].value;
        }
      }
    );
  }

  /** インデックス作成 */
  private async createIndex() {
    if (!this.form.validate()) {
      await this.$openAlert("入力内容に不備があります。");
      return;
    }

    if (!(await this.$openConfirm("インデックスを作成しますか？"))) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/index/create",
      {
        dataset_id: this.datasetId,
        yearmonth: this.yearmonth,
        process_limit: this.processLimit,
      },
      async () => {
        await this.$openAlert("作成を開始しました。");
        this.fetch();
        this.moveToIndexConfigPage();
      }
    );
  }

  /** 表のページ変更 */
  private changePage(pageNo: number) {
    this.pageNo = pageNo;
  }

  /** データセット取得 */
  private fetchDataset() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/datasets/get",
      {},
      async (res) => {
        this.datasets = res.data.datasets;
      }
    );
  }

  /** キャンセル */
  private cancel() {
    this.moveToIndexConfigPage();
  }

  /** インデックス設定画面へ遷移 */
  private moveToIndexConfigPage() {
    this.$router.push({ path: "/ai-vnplan/index/config" });
  }

  /** データセット編集画面へ遷移 */
  private moveDatasetEditPage(id: number) {
    this.$router.push({
      path: `/ai-vnplan/dataset/edit/${id}`,
      query: { fromType: "1" },
    });
  }
}
